module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    ref: "rtButton",
    staticClass: "rt-button",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.computedDisabled || _vm.loading,
      "autofocus": _vm.autofocus,
      "type": "button"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "rt-button-content"
  }, [_c('rt-icon', {
    attrs: {
      "name": "rt-base-loading",
      "size": _vm.loadingSize
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-save"
  }, [_vm._v("\n      " + _vm._s(_vm.loadingText) + "\n    ")])], 1) : _c('span', {
    staticClass: "rt-button-content"
  }, [(_vm.iconName) ? _c('rt-icon', {
    attrs: {
      "name": _vm.iconName,
      "size": _vm.iconSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasdefault) ? _c('span', {
    staticClass: "rt-button-text"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.hasDivider) ? _c('rt-divider', {
    attrs: {
      "direction": _vm.direction
    }
  }) : _vm._e(), _vm._v(" "), (_vm.suffixIcon) ? _c('rt-icon', {
    attrs: {
      "name": _vm.suffixIcon,
      "size": _vm.iconSize
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.tooltip) ? _c('rt-tooltip', {
    ref: "rtButtonTooltip",
    attrs: {
      "popper-class": "rt-button-tooltip",
      "content": String(_vm.tooltip),
      "placement": "bottom"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "-1px",
      "left": "-1px"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-266157d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/button/rtButton.vue
// module id = 2091
// module chunks = 137